import { render, staticRenderFns } from "./AddToCartIconButton.vue?vue&type=template&id=6c7aa384&scoped=true&"
import script from "./AddToCartIconButton.vue?vue&type=script&lang=ts&"
export * from "./AddToCartIconButton.vue?vue&type=script&lang=ts&"
import style0 from "./AddToCartIconButton.vue?vue&type=style&index=0&id=6c7aa384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7aa384",
  null
  
)

export default component.exports